import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { Company } from 'store/companies';
import { ICompany, IBaseCompany } from 'types/income';

interface GetCompanies {
  clientId: string;
}

interface GetCompany {
  companyId: string;
}

interface UpdateCompanySettings {
  companyId: string;
  settings: Partial<Omit<Company['settings'], 'sourceOfRecognitionPoints'>>;
}

export const loaders = {
  getCompanies: ({ clientId }: GetCompanies) => {
    return api<{ data: IBaseCompany[] }>({
      url: Endpoints.clientAdmin.clients.byId.companies.root.replace(
        ':clientId',
        clientId,
      ),
      context: 'melp',
    });
  },
  getCompany: ({ companyId }: GetCompany) => {
    return api<ICompany>({
      url: Endpoints.clientAdmin.companies.byId.root.replace(
        ':companyId',
        companyId,
      ),
      context: 'melp',
    });
  },
  updateCompanySettings: ({ companyId, settings }: UpdateCompanySettings) => {
    return api({
      url: Endpoints.clientAdmin.companies.byId.settings.replace(
        ':companyId',
        companyId,
      ),
      context: 'melp',
      data: settings,
      method: 'patch',
    });
  },
};
